module.exports = __webpack_public_path__ + "img/Upload.68d85ecf.svg";